"use client"

import { Plus } from "lucide-react"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { StandardButton } from "@/styles/StandardButtons"
import type { GanttTask } from "../gantt-chart/data/types"

/**
 * "Add Task" control shared by Gantt's own toolbar and List's toolbar
 * (spec: "reutiliza exactamente el mismo flujo de creación existente") --
 * one phase creates directly, several phases show a picker, zero phases
 * disables the button. Both callers pass the SAME ganttData.addTask.
 */
export function AddTaskButton({ phases, onAddTask, className }: { phases: GanttTask[]; onAddTask: (phaseId: string) => void; className?: string }) {
  if (phases.length === 0) {
    return (
      <StandardButton customVariant="blue" disabled className={className}>
        <Plus className="mr-1.5 h-3.5 w-3.5" />
        Add Task
      </StandardButton>
    )
  }
  if (phases.length === 1) {
    return (
      <StandardButton customVariant="blue" onClick={() => onAddTask(phases[0].id)} className={className}>
        <Plus className="mr-1.5 h-3.5 w-3.5" />
        Add Task
      </StandardButton>
    )
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <span>
          <StandardButton customVariant="blue" className={className}>
            <Plus className="mr-1.5 h-3.5 w-3.5" />
            Add Task
          </StandardButton>
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white border border-gray-200 shadow-lg">
        {phases.map((p) => (
          <DropdownMenuItem key={p.id} onClick={() => onAddTask(p.id)} className="cursor-pointer focus:bg-gray-100 data-[highlighted]:bg-gray-100 font-button">
            {p.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
